var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c(
                "b-col",
                { staticClass: "mb-2", attrs: { cols: "12" } },
                [
                  _c("b-skeleton", {
                    attrs: {
                      animation: "fade",
                      width: "100%",
                      height: "1.25rem",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(5, function (i) {
        return _c(
          "b-col",
          { key: i, attrs: { cols: "12" } },
          [
            _c(
              "b-row",
              { staticClass: "align-items-center" },
              [
                _c(
                  "b-col",
                  { staticClass: "mb-1", attrs: { cols: "1" } },
                  [
                    _c("b-skeleton", {
                      attrs: {
                        animation: "fade",
                        width: "100%",
                        height: "2rem",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "mb-1", attrs: { cols: "5" } },
                  [
                    _c("b-skeleton", {
                      attrs: {
                        animation: "fade",
                        width: "100%",
                        height: "1.5rem",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "mb-1", attrs: { cols: "2" } },
                  [
                    _c("b-skeleton", {
                      attrs: {
                        animation: "fade",
                        width: "100%",
                        height: "1.5rem",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "mb-1", attrs: { cols: "2" } },
                  [
                    _c("b-skeleton", {
                      attrs: {
                        animation: "fade",
                        width: "100%",
                        height: "1.5rem",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { cols: "2" } },
                  [
                    _c("b-skeleton", {
                      attrs: {
                        animation: "fade",
                        width: "100%",
                        height: "1.5rem",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }